import React, { useEffect } from 'react';
import { Skeleton } from 'antd';
import { GetStaticProps } from 'next';
import { useTranslations } from 'next-intl';

import { useAppDispatch } from 'store';

import { openAuthModal } from 'modules/auth';
import { isEmptyArr, useUserData } from 'modules/global';
import { Banner, OlympicCard, useActiveOlympic, useFinishedOlympic } from 'modules/online-olympic';

import { EmptyData, NextHead, Visible } from 'components';

const Index = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch()
  const { finishedOlympic, isLoading } = useFinishedOlympic();
  const { activeOlympic, isLoading: activeOlympicLoading } = useActiveOlympic();
  const { user, isLoading: isLoadingUser, isFetching: isFetchingUser } = useUserData();

  useEffect(() => {
    if (isLoadingUser || isFetchingUser ? false : !user?.phone) dispatch(openAuthModal());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isLoadingUser, isFetchingUser]);

  return (
    <>
      <NextHead title={t('meta.olympic.title')} description={t('meta.olympic.description')} />

      <div className="max-w-244.5 mx-auto min-h-screen p-4 md:my-7">
        <h1 className="text-xl font-bold text-gray-900 md:text-2xl">{t('olimpiada')}</h1>
        {!isEmptyArr(activeOlympic) && <Banner activeOlympic={activeOlympic} isLoading={activeOlympicLoading} />}

        <div className="mt-5">
          <h3 className="text-sm font-medium md:text-sm">{t('tuganlangan_turnirlar')}</h3>
          <Visible
            if={isLoading || isLoadingUser || isFetchingUser}
            else={
              <Visible
                if={isEmptyArr(finishedOlympic)}
                else={
                  <div className="mt-3 space-y-3">
                    {finishedOlympic?.map(finished => <OlympicCard key={finished?.id} finishedOlympic={finished} />)}
                  </div>
                }
              >
                <EmptyData title={t('tugallangan_turnirlar_mavjud_emas')} />
              </Visible>
            }
          >
            {Array.from({ length: 4 }).map((_, index) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className="h-44.5 relative mt-3 flex flex-col justify-between overflow-hidden rounded-xl bg-white p-2 sm:p-3"
              >
                <div>
                  <Skeleton.Input className="!h-6 !w-60" />

                  <div className="mt-2 grid grid-cols-4 items-center gap-2 sm:gap-3">
                    {Array.from({ length: 4 }).map((_, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <Skeleton.Button key={index} active className="!h-16 !w-full !rounded-lg" />
                    ))}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <Skeleton.Input className="!h-6 !w-80" />
                  <Skeleton.Input className="!h-10 !w-40 !rounded-lg" />
                </div>
              </div>
            ))}
          </Visible>
        </div>
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    messages: (await import(`../../messages/${locale}.json`)).default
  }
});
